import {RegExpUtil} from '@aperza/util';

export default class PathUtil {

  static currentPath() {
    if (window && window.location) {
      return window.location.pathname;
    }
    return '';
  }

  static prefixRegExp(langCode) {
    let prefix = '^\/[A-Za-z]{2}\/';
    if (langCode) {
      prefix = `^\/${langCode}\/`;
    }
    return prefix;
  }

  static isCatalogPage(path = PathUtil.currentPath(), langCode) {
    let pattern = `${PathUtil.prefixRegExp(langCode)}co\/([0-9]*)\/catalog\/.*`;
    return RegExpUtil.test(pattern, path);
  }

  static isSearchCatalogPage(path = PathUtil.currentPath(), langCode) {
    let pattern = `${PathUtil.prefixRegExp(langCode)}s\\/catalog.*`;
    return RegExpUtil.test(pattern, path);
  }

}
